import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {ProcedureFallbackProps} from './types';

const {tryAgain} = translations['pt-br'].commons;

export function ProcedureFallback({
	title,
	description,
	variant = 'empty',
	onRetry,
}: ProcedureFallbackProps) {
	const theme = useTheme();

	return (
		<Stack
			gap={2}
			padding="24px 16px"
			alignItems="center"
			justifyContent="center">
			<Icon
				name={variant === 'error' ? 'info-outlined' : 'search-default'}
				color={theme.palette.action.disabled}
				size={40}
			/>
			<Stack gap={variant === 'error' ? 1 : 0}>
				<Typography variant="h6" textAlign="center" color="text.secondary">
					{title}
				</Typography>
				<Typography
					variant="body1"
					maxWidth="502px"
					textAlign="center"
					color="text.secondary">
					{description}
				</Typography>
			</Stack>
			{variant === 'error' && onRetry ? (
				<Button
					variant="outlined"
					color="primary"
					onClick={onRetry}
					endIcon={<Icon name="cached-default" />}>
					{tryAgain}
				</Button>
			) : null}
		</Stack>
	);
}
